import { render, staticRenderFns } from "./dialogFormPreview.vue?vue&type=template&id=3d23d918&scoped=true"
import script from "./dialogFormPreview.vue?vue&type=script&lang=js"
export * from "./dialogFormPreview.vue?vue&type=script&lang=js"
import style0 from "./dialogFormPreview.vue?vue&type=style&index=0&id=3d23d918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23d918",
  null
  
)

export default component.exports